import type { ProjectDocument } from './types';

export interface TopologyHistoryState {
  future: ProjectDocument[];
  past: ProjectDocument[];
  present: ProjectDocument;
}

export type TopologyHistoryAction =
  | { document: ProjectDocument; type: 'commit' }
  | { document: ProjectDocument; type: 'reset' }
  | { type: 'redo' }
  | { type: 'undo' };

export function createTopologyHistory(
  document: ProjectDocument,
): TopologyHistoryState {
  return { future: [], past: [], present: document };
}

export function topologyHistoryReducer(
  state: TopologyHistoryState,
  action: TopologyHistoryAction,
): TopologyHistoryState {
  switch (action.type) {
    case 'commit':
      return {
        future: [],
        past: [...state.past, state.present],
        present: action.document,
      };
    case 'reset':
      return createTopologyHistory(action.document);
    case 'undo': {
      const previous = state.past.at(-1);
      if (previous === undefined) {
        return state;
      }
      return {
        future: [state.present, ...state.future],
        past: state.past.slice(0, -1),
        present: previous,
      };
    }
    case 'redo': {
      const next = state.future[0];
      if (next === undefined) {
        return state;
      }
      return {
        future: state.future.slice(1),
        past: [...state.past, state.present],
        present: next,
      };
    }
  }
}
